import { Component, Input, inject } from '@angular/core';
import { ModalController } from '@ionic/angular/standalone';
import { IonHeader, IonToolbar, IonTitle, IonContent, IonButton, IonIcon } from '@ionic/angular/standalone';
import { addIcons } from 'ionicons';
import { cloudDownloadOutline, close } from 'ionicons/icons';
import { AppVersionService } from '../services/app-version.service';

@Component({
  selector: 'app-update-required-modal',
  standalone: true,
  imports: [IonHeader, IonToolbar, IonTitle, IonContent, IonButton, IonIcon],
  template: `
    <ion-header>
      <ion-toolbar>
        <ion-title>Update available</ion-title>
      </ion-toolbar>
    </ion-header>
    <ion-content class="ion-padding">
      <div class="update-modal-content">
        <ion-icon name="cloud-download-outline" class="update-icon"></ion-icon>
        <h2 class="update-title">A new version is available</h2>
        <p class="update-message">
          Please update to version {{ latestVersion }} to get the latest features and fixes.
        </p>
        <div class="update-actions">
          <ion-button expand="block" color="primary" (click)="openStore()">
            Update now
          </ion-button>
          @if (!forceUpdate) {
            <ion-button expand="block" fill="outline" (click)="later()">
              Later
            </ion-button>
          }
        </div>
      </div>
    </ion-content>
  `,
  styles: [`
    :host {
      --ion-background-color: #ffffff;
    }
    .update-modal-content {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 1.5rem 1rem 2rem;
      text-align: center;
    }
    .update-icon {
      font-size: 4rem;
      color: var(--ion-color-primary, #3880ff);
      margin-bottom: 1rem;
    }
    .update-title {
      font-size: 1.25rem;
      font-weight: 700;
      color: #1e293b;
      margin: 0 0 0.5rem;
    }
    .update-message {
      color: #64748b;
      margin: 0 0 1.5rem;
      font-size: 0.9375rem;
    }
    .update-actions {
      width: 100%;
      display: flex;
      flex-direction: column;
      gap: 0.75rem;
    }
  `],
})
export class UpdateRequiredModalComponent {
  @Input() storeUrl!: string;
  @Input() latestVersion!: string;
  @Input() forceUpdate = false;

  private readonly modalController = inject(ModalController);
  private readonly appVersionService = inject(AppVersionService);

  constructor() {
    addIcons({ cloudDownloadOutline, close });
  }

  openStore(): void {
    if (this.storeUrl) {
      window.open(this.storeUrl, '_blank');
    }
    void this.modalController.dismiss();
  }

  later(): void {
    this.appVersionService.setUpdateDismissed();
    void this.modalController.dismiss();
  }
}
